import {
  FETCH_AGING_DASHBOARD,
  FETCH_AGING_DASHBOARD_SUCCESS,
  FETCH_AGING_DASHBOARD_FAILURE,
  FETCH_AGING_TABLE,
  FETCH_AGING_TABLE_SUCCESS,
  FETCH_AGING_TABLE_FAILURE,
  FETCH_AGING_ZONE_BREAKDOWN,
  FETCH_AGING_ZONE_BREAKDOWN_SUCCESS,
  FETCH_AGING_ZONE_BREAKDOWN_FAILURE,
  FETCH_COLLECTION_DAYS,
  FETCH_COLLECTION_DAYS_SUCCESS,
  FETCH_COLLECTION_DAYS_FAILURE,
  UPLOAD_AGING_ANALYSIS,
  UPLOAD_AGING_ANALYSIS_SUCCESS,
  UPLOAD_AGING_ANALYSIS_FAILURE,
  UPLOAD_COLLECTION_DAYS,
  UPLOAD_COLLECTION_DAYS_SUCCESS,
  UPLOAD_COLLECTION_DAYS_FAILURE,
  FETCH_SALES_TARGET,
  FETCH_SALES_TARGET_SUCCESS,
  FETCH_SALES_TARGET_FAILURE,
  UPLOAD_SALES_TARGET,
  UPLOAD_SALES_TARGET_SUCCESS,
  UPLOAD_SALES_TARGET_FAILURE,
} from '../constants/ActionsTypes'

const initialState = {
  dashboard: {
    data: null,
    loading: false,
    error: null,
  },
  table: {
    data: [],
    pagination: { page: 1, pageSize: 20, total: 0, totalPages: 0 },
    filters: {},
    loading: false,
    error: null,
  },
  collectionDays: {
    data: [],
    total: null,
    loading: false,
    error: null,
  },
  salesTarget: {
    data: [],
    companyObjective: null,
    loading: false,
    error: null,
  },
  zoneBreakdown: {
    data: [],
    loading: false,
    error: null,
  },
  uploadAging: {
    loading: false,
    error: null,
  },
  uploadCollectionDays: {
    loading: false,
    error: null,
  },
  uploadSalesTarget: {
    loading: false,
    error: null,
  },
}

function rootReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_AGING_DASHBOARD:
      return { ...state, dashboard: { ...state.dashboard, loading: true, error: null } }
    case FETCH_AGING_DASHBOARD_SUCCESS:
      return { ...state, dashboard: { data: action.payload, loading: false, error: null } }
    case FETCH_AGING_DASHBOARD_FAILURE:
      return { ...state, dashboard: { ...state.dashboard, loading: false, error: action.payload } }

    case FETCH_AGING_TABLE:
      return { ...state, table: { ...state.table, loading: true, error: null } }
    case FETCH_AGING_TABLE_SUCCESS: {
      const { data, metadata } = action.payload || {}
      return {
        ...state,
        table: {
          ...state.table,
          data: data || [],
          pagination: (metadata && metadata.pagination) || state.table.pagination,
          filters: (metadata && metadata.filters) || state.table.filters,
          loading: false,
          error: null,
        },
      }
    }
    case FETCH_AGING_TABLE_FAILURE:
      return { ...state, table: { ...state.table, loading: false, error: action.payload } }

    case FETCH_AGING_ZONE_BREAKDOWN:
      return { ...state, zoneBreakdown: { ...state.zoneBreakdown, loading: true, error: null } }
    case FETCH_AGING_ZONE_BREAKDOWN_SUCCESS:
      return { ...state, zoneBreakdown: { data: action.payload || [], loading: false, error: null } }
    case FETCH_AGING_ZONE_BREAKDOWN_FAILURE:
      return {
        ...state,
        zoneBreakdown: { ...state.zoneBreakdown, loading: false, error: action.payload },
      }

    case FETCH_COLLECTION_DAYS:
      return { ...state, collectionDays: { ...state.collectionDays, loading: true, error: null } }
    case FETCH_COLLECTION_DAYS_SUCCESS: {
      const { data, total } = action.payload || {}
      return {
        ...state,
        collectionDays: { data: data || [], total: total || null, loading: false, error: null },
      }
    }
    case FETCH_COLLECTION_DAYS_FAILURE:
      return {
        ...state,
        collectionDays: { ...state.collectionDays, loading: false, error: action.payload },
      }

    case FETCH_SALES_TARGET:
      return { ...state, salesTarget: { ...state.salesTarget, loading: true, error: null } }
    case FETCH_SALES_TARGET_SUCCESS: {
      const { data, companyObjective } = action.payload || {}
      return {
        ...state,
        salesTarget: {
          data: data || [],
          companyObjective: companyObjective != null ? companyObjective : null,
          loading: false,
          error: null,
        },
      }
    }
    case FETCH_SALES_TARGET_FAILURE:
      return {
        ...state,
        salesTarget: { ...state.salesTarget, loading: false, error: action.payload },
      }

    case UPLOAD_AGING_ANALYSIS:
      return { ...state, uploadAging: { loading: true, error: null } }
    case UPLOAD_AGING_ANALYSIS_SUCCESS:
      return { ...state, uploadAging: { loading: false, error: null } }
    case UPLOAD_AGING_ANALYSIS_FAILURE:
      return { ...state, uploadAging: { loading: false, error: action.payload } }

    case UPLOAD_COLLECTION_DAYS:
      return { ...state, uploadCollectionDays: { loading: true, error: null } }
    case UPLOAD_COLLECTION_DAYS_SUCCESS:
      return { ...state, uploadCollectionDays: { loading: false, error: null } }
    case UPLOAD_COLLECTION_DAYS_FAILURE:
      return { ...state, uploadCollectionDays: { loading: false, error: action.payload } }

    case UPLOAD_SALES_TARGET:
      return { ...state, uploadSalesTarget: { loading: true, error: null } }
    case UPLOAD_SALES_TARGET_SUCCESS:
      return { ...state, uploadSalesTarget: { loading: false, error: null } }
    case UPLOAD_SALES_TARGET_FAILURE:
      return { ...state, uploadSalesTarget: { loading: false, error: action.payload } }

    default:
      return state
  }
}

export default rootReducer
